import React from "react";

function Main(){
    return (
        <section className="middle_content">
        <div className="photo_first">
        <div className="slider"></div>
            <div className="text1">
                <h1>Visit Yatra</h1>
                <h1>You wont regret.</h1>
                <h1>Enjoy Your Holiday.</h1>

            </div>
            <div className="btn_first">
                <button type="submit"><a href="/trek">Explore Routes</a></button>
            </div>
        </div>
    </section>
    )
}

export default Main;